<template>
  <div class="send-record">
    <div class="main-title">
      <p @click="toList">
        {{ deviceType == 4 ? $t('lang.Charging charge station management') : $t('lang.Change charge station management') }}</p>
      <p @click="toDetail">>{{ $t('lang.Details') }}</p>
      <p>>{{ $t('lang.sending request record') }}</p>
    </div>
    <div class="main-body">
      <div class="list">
        <div class="name-label">{{ $t('lang.Equipment number') }}：</div>
        <div class="value-label">{{ primaryDeviceNo }}</div>
      </div>
      <div class="list">
        <span>{{ $t('lang.time') }}：</span>
        <el-date-picker
          v-model="startTime"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
          :placeholder="$t('lang.start time')">
        </el-date-picker>
        --
        <el-date-picker
          v-model="endTime"
          type="datetime"
          format="yyyy-MM-dd HH:mm"
          value-format="yyyy-MM-dd HH:mm"
          :placeholder="$t('lang.end time')">
        </el-date-picker>
        <span class="ml10">{{ $t('lang.Port number') }}：</span>
        <el-input class="list-input" size="mini" v-model="chargePortSeqNo"></el-input>
        <span class="ml10">{{ $t('lang.type') }}：</span>
        <el-select class="list-input" size="mini" v-model="sourceType">
          <el-option v-for="(item, index) in sourceTypeList" :key="index" :value="item.value"
                     :label="item.label"></el-option>
        </el-select>
        <div class="blue-btn ml10" @click="onQueryBtnClick">{{ $t('lang.Inquire') }}</div>
      </div>
      <!-- <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column prop="name" label="请求编号"></el-table-column>
        <el-table-column prop="name" label="发送时间"></el-table-column>
        <el-table-column prop="path" label="端口编号"></el-table-column>
        <el-table-column prop="icon" label="类型"></el-table-column>
        <el-table-column prop="sort" label="操作人"></el-table-column>
        <el-table-column prop="sort" label="内容"></el-table-column>
        <el-table-column prop="sort" label="操作原因"></el-table-column>
        <el-table-column prop="sort" label="状态">
          <template slot-scope="{row}">
          </template>
        </el-table-column>
      </el-table>
      <div class="dfcc">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          prev-text="上一页"
          next-text="下一页"
          layout=" prev, next"
          :total="total">
        </el-pagination>
      </div> -->
      <table class="table-custom">
        <thead>
        <tr>
          <th>{{ $t('lang.Request number') }}</th>
          <th>{{ $t('lang.Send time') }}</th>
          <th>{{ $t('lang.Port number') }}</th>
          <th>{{ $t('lang.type') }}</th>
          <th>{{ $t('lang.content') }}</th>
          <th> {{ $t('lang.operator') }}</th>
          <th> {{ $t('lang.status') }}</th>
        </tr>
        </thead>
        <tbody v-if="dataList.length>0">
        <tr v-for="(item,index) in dataList" :key="index">
          <td>{{ item.requestNo }}</td>
          <td>{{ $changeTime.showTime(item.createTime) }}</td>
          <td>{{ item.chargePortSeqNo ? item.chargePortSeqNo + $t('lang.No') : "--" }}</td>
          <td>{{ $t('lang.' + $changeObj(source_Type_Code)[item.sourceTypeCode]) }}</td>
          <td>{{ $t('lang.' + $changeObj(operate_type_code)[item.operateTypeCode]) }}</td>
          <td>{{ item.operationUserPhone }}</td>
          <td>{{ $t('lang.' + $changeObj(status_Code)[item.statusCode]) }}</td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan='7'> {{ $t('lang.no data') }}</td>
        </tr>
        </tbody>
      </table>
      <div class="page-box">
        <div class="pre-btn" :class="preBtnDisabled?'disabled':''" @click="onPreBtnClick">
          {{ $t('lang.Previous page') }}
        </div>
        <div class="next-btn" :class="nextBtnDisabled?'disabled':''" @click="onNextBtnClick">
          {{ $t('lang.Next page') }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Utils from "../../utils/utils";
import {source_Type_Code, operate_type_code, status_Code} from '@/utils/constant'

export default {
  name: 'sendRecord',
  data() {
    return {
      status_Code,
      operate_type_code,
      source_Type_Code,
      tableData: [],
      total: 0,
      title: '',
      deviceType: '',
      pageSize: 10,
      beginIndex: 0,
      preBtnDisabled: true,
      nextBtnDisabled: false,
      startTime: '',
      endTime: '',
      chargePortSeqNo: '',
      primaryDeviceNo: '',
      dataList: [],
      searchCondition: '',
      deviceName: '',
      begin: 0,
      sourceTypeList: [
        {
          value: '',
          label: this.$t('lang.all')
        },
        {
          value: '1',
          label: this.$t('lang.Old Charging Service')
        },
        {
          value: '2',
          label: this.$t('lang.Power Changing Service')
        },
        {
          value: '3',
          label: this.$t('lang.Operational records')
        },
        {
          value: '4',
          label: this.$t('lang.In electrical service user additional operations')
        },
        {
          value: '5',
          label: this.$t('lang.New Charging Services')
        },
        {
          value: '6',
          label: this.$t('lang.System request')
        },
        {
          value: '7',
          label: this.$t('lang.Charging cabinet charging service')
        },
        {
          value: '8',
          label: this.$t('lang.Charging cabinet service door reminder')
        },
        {
          value: '9',
          label: this.$t('lang.Charging cabinet service user additional operation')
        },
        {
          value: '10',
          label: this.$t('lang.Remote upgrade of cabinet')
        },
        {
          value: '11',
          label: this.$t('lang.Get the battery')
        },
        {
          value: '12',
          label: this.$t('lang.Receive batteries for additional operations')
        },
        {
          value: '13',
          label: this.$t('lang.Return battery')
        },
        {
          value: '14',
          label: this.$t('lang.Return the battery for additional operation')
        }
      ],
      sourceType: ''
    }
  },
  mounted() {
    this.startTime = Utils.getCurrentDate() + " 00:00";
    this.endTime = Utils.getCurrentDate() + " 23:59";
    if (this.$route.query.primaryDeviceNo) {
      this.primaryDeviceNo = this.$route.query.primaryDeviceNo;
      this.querySendRecord();
    }
    if (this.$route.query.searchCondition) {
      this.searchCondition = this.$route.query.searchCondition;
    }
    if (this.$route.query.deviceName) {
      this.deviceName = this.$route.query.deviceName;
    }
    if (this.$route.query.beginIndex) {
      this.begin = this.$route.query.beginIndex;
    }
    if (this.$route.query.deviceType) {
      this.deviceType = this.$route.query.deviceType;
    }
  },
  methods: {
    // 分页
    // handleCurrentChange(i){

    // },

    querySendRecord() {
      let self = this;
      let params = {
        primaryDeviceNo: this.primaryDeviceNo,
        chargePortSeqNo: this.chargePortSeqNo,
        beginIndex: this.beginIndex,
        pageSize: this.pageSize + 1,
        beginTime: this.$changeTime.sendTime(this.startTime, 'YYYY-MM-DD HH:mm'),
        endTime: this.$changeTime.sendTime(this.endTime, 'YYYY-MM-DD HH:mm'),
        operateType: 3,
        sourceType: this.sourceType
      };
      this.$http.post('/managementPlatform/electricity/queryDeviceRequest', this.$qs.stringify(params)).then(function (response) {
        let res = response.data;
        if (!res || !res.result) {
          self.$message({
            type: "error",
            message: res.message || self.$t('lang.Query failed'),
            center: true
          });
          return;
        }
        self.dataList = res.ldata;
        self.resetPreAndNextBtn(self.dataList.length);
        self.dataList.length > self.pageSize && self.dataList.pop();
      }).catch(function (response) {
        console.log(response);
      });
    },
    onPreBtnClick() {
      if (this.preBtnDisabled) {
        return;
      }
      this.beginIndex <= this.pageSize && (this.beginIndex = 0);
      this.beginIndex > this.pageSize && (this.beginIndex -= this.pageSize);
      this.querySendRecord();
    },
    onNextBtnClick() {
      if (this.nextBtnDisabled) {
        return;
      }
      this.beginIndex += this.pageSize;
      this.querySendRecord();
    },
    resetPreAndNextBtn(length) {
      this.beginIndex == 0 && (this.preBtnDisabled = true);
      this.beginIndex > 0 && (this.preBtnDisabled = false);
      length > this.pageSize && (this.nextBtnDisabled = false);
      length <= this.pageSize && (this.nextBtnDisabled = true);
    },
    onQueryBtnClick() {
      this.beginIndex = 0;
      this.querySendRecord();
    },
    toList() {
      if (this.deviceType == 4) {
        this.$router.push("/managePage/chargeCabinetMgmt?searchCondition=" + this.searchCondition + "&deviceName=" + this.deviceName + "&beginIndex=" + this.begin);
      } else {
        this.$router.push("/managePage/batterySwapMgmt?searchCondition=" + this.searchCondition + "&deviceName=" + this.deviceName + "&beginIndex=" + this.begin);
      }
    },
    toDetail() {
      if (this.deviceType == 4) {
        this.$router.push("/managePage/chargeCabinetMgmt?primaryDeviceNo=" + this.primaryDeviceNo + "&searchCondition=" + this.searchCondition + "&deviceName=" + this.deviceName + "&beginIndex=" + this.begin);
      } else {
        this.$router.push("/managePage/batterySwapMgmt?primaryDeviceNo=" + this.primaryDeviceNo + "&searchCondition=" + this.searchCondition + "&deviceName=" + this.deviceName + "&beginIndex=" + this.begin);
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.list {
  line-height: 30px;
  margin: 20px 30px 10px;
  overflow: hidden;

  .name-label {
    float: left;
  }

  .value-label {
    float: left;
    width: 17%;
    height: 30px;
  }

  .date-global {
    width: 185px;
  }

  .list-input {
    width: 180px;
  }
}

.table-custom {
  width: 100%;

  .text-btn {
    width: 50px;
    height: 24px;
    line-height: 24px;
    color: #417505;
    display: inline-block;
    background-color: #BEE6B3;
    cursor: pointer;
  }

  .fixed-width-75 {
    width: 75px;
  }

  .fixed-width-120 {
    width: 120px;
  }

  .fixed-width-60 {
    width: 60px;
  }
}

.ml-40 {
  margin-left: 40px;
}

.pre-btn {
  width: 84px;
}
</style>



// WEBPACK FOOTER //
// src/components/deviceMgmt/sendRecord.vue